
import React from "react";
import "../../styles/PrimaryBTN.css";
import { withNamespaces } from 'react-i18next';

const BackBTN = (props) => {
  return (
    <div className="text-start" onClick={props.click}>
      <button className="BTNback">
        <a href={props.link} title={props.title}>
          <span className="circle_BTNback" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span className="button-text_BTNback">{props.texto}</span>
        </a>
      </button>
    </div>
  );
};

export default withNamespaces() (BackBTN);

